import { useState, useCallback } from 'react';
import { RootState } from 'client/_redux/reducers';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { generateMyReport } from 'client/_redux/services/user';
import { getUserReports } from 'client/_redux/actions/post';
import { toast } from 'react-toastify';

export const useModalReport = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [isGenerating, setIsGenerating] = useState(false);
  const alertMsg = t('ProfileContainer.WalletTab.reportModel.alertMsg');
  const ModalTitle = t('ProfileContainer.WalletTab.reportModel.title');
  const alertMsgReport = t('ProfileContainer.WalletTab.reportModel.alertMsgReport');
  const reportext = t('ProfileContainer.WalletTab.reportModel.reportext');
  const textTranslations = { alertMsg, ModalTitle, alertMsgReport, reportext };
  const { userReports } = useSelector(({ auth: { userReports } }: RootState) => ({
    userReports,
  }));

  const handleGenerateReport = useCallback(async () => {
    setIsGenerating(true);
    try {
      const result = await generateMyReport();

      if (result.message) {
        toast(result.message, { type: 'info' });
      } else {
        toast('Report generated successfully', { type: 'success' });
        dispatch(getUserReports());
      }
    } catch (error) {
      toast('Failed to generate report', { type: 'error' });
    }
    setIsGenerating(false);
  }, [dispatch]);

  return { textTranslations, userReports, handleGenerateReport, isGenerating };
};
